export enum VpnVersion {
    V1 = 'V1',
}
